import { USE_MOCKS } from '../config/serviceConfig';
import { courseMock } from './mock/course.mock';
import { courseReal } from './real/course.real';
import type { ICourseService } from './interfaces/ICourseService';

export const courseService: ICourseService = USE_MOCKS
  ? courseMock
  : courseReal;
